import React from 'react';
import clsx from 'clsx';

import './SubscriptionPlanItem.scss';
import { Typography } from '@mui/material';

interface SubscriptionPlanItemProps {
  title: string;
  priceString?: string;
  discountedOriginalPriceString?: string;
  isSelected: boolean;
  customDiscountLabel?: string;
  customDiscountLabelColor?: string;
  customDiscountLabelTextColor?: string;
  onClick: () => void;
  className?: string;
  trialDays?: number;
}

const SubscriptionPlanItem: React.FC<SubscriptionPlanItemProps> = ({
  title,
  priceString,
  discountedOriginalPriceString,
  isSelected,
  customDiscountLabel,
  customDiscountLabelColor,
  customDiscountLabelTextColor,
  onClick,
  className,
  trialDays,
}) => {
  const labelBgColor =
    customDiscountLabelColor ||
    (isSelected ? 'var(--color-white-lightest)' : 'var(--color-primary)');
  const labelTextColor =
    customDiscountLabelTextColor ||
    (isSelected ? 'var(--color-black)' : 'var(--color-white-lightest)');

  return (
    <div
      className={clsx(
        'subscription-plan-item-new',
        isSelected && 'subscription-plan-item-new--selected',
        className
      )}
      onClick={onClick}
    >
      {/* Label */}
      {customDiscountLabel ? (
        <div
          className="subscription-plan-item-new__badge"
          style={{ backgroundColor: labelBgColor }}
        >
          <Typography
            variant="subtitle2"
            className="subscription-plan-item-new__badge__text"
            style={{ color: labelTextColor }}
          >
            {customDiscountLabel}
          </Typography>
        </div>
      ) : (
        <div className="subscription-plan-item-new__badge" />
      )}

      {/* Price */}
      {customDiscountLabel && discountedOriginalPriceString ? (
        <div className="subscription-plan-item-new__price-container">
          <Typography
            variant="body2"
            className="subscription-plan-item-new__original-price"
            style={{
              textDecoration: 'line-through',
              opacity: 0.6,
              fontSize: 'var(--font-size-xs)',
            }}
          >
            {discountedOriginalPriceString}
          </Typography>
          <Typography variant="body1" className="subscription-plan-item-new__price">
            {priceString}
          </Typography>
        </div>
      ) : (
        <Typography variant="body1" className="subscription-plan-item-new__price">
          {priceString}
        </Typography>
      )}

      {/* Title */}
      <Typography variant="h6" className="subscription-plan-item-new__title">
        {title}
      </Typography>

      {/* Trial */}
      {trialDays !== undefined && (
        <>
          {trialDays > 0 ? (
            <Typography variant="subtitle2" className="subscription-plan-item-new__trial">
              <span className="subscription-plan-item-new__trial--strong">{trialDays} days</span>{' '}
              free trial
            </Typography>
          ) : (
            <Typography variant="subtitle2" className="subscription-plan-item-new__trial">
              No free trial
            </Typography>
          )}
        </>
      )}
    </div>
  );
};

export default SubscriptionPlanItem;
